export class ForgotUserNamedModel {
    Email = '';
}